/*
 * My Garage — the vehicle store UI (header panel, Change/Remove, previous vehicles).
 *
 * Reads go through window.NewarkYMM (assets/ymm-core.js); this file owns the WRITES
 * to newark_garage_v1 and the history key. (Was: read by ymm-search.js, the header
 * pre-paint script, and ymm-fitment.js). Recently used vehicles live in
 * newark_garage_history_v1 (most recent first, capped) and appear in the header
 * garage panel as "Previous vehicles" for one-click switching.
 *
 * The header pill toggles a panel with plain-word actions: Shop parts for this car,
 * Change vehicle, Remove, previous vehicles. All mutations announce on the
 * 'ymm:vehicle' event so the banner and PDP fitment box stay in sync.
 */
(function () {
  var KEY = 'newark_garage_v1';
  var HKEY = 'newark_garage_history_v1';
  var HISTORY_SHOWN = 3;

  function read() { return NewarkYMM.getVehicle(); }
  function write(v) {
    try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {}
  }
  function history() {
    try { var h = JSON.parse(localStorage.getItem(HKEY) || '[]'); return Array.isArray(h) ? h : []; } catch (e) { return []; }
  }
  var label = NewarkYMM.label;
  function pushHistory(v) {
    if (!v || !v.make) return;
    var h = history().filter(function (x) { return label(x) !== label(v); });
    h.unshift({ make: v.make, model: v.model || '', year: v.year || '' });
    try { localStorage.setItem(HKEY, JSON.stringify(h.slice(0, HISTORY_SHOWN + 1))); } catch (e) {}
  }
  function removeHistory(lbl) {
    var h = history().filter(function (x) { return label(x) !== lbl; });
    try { localStorage.setItem(HKEY, JSON.stringify(h)); } catch (e) {}
  }
  function clearHistory() {
    try { localStorage.removeItem(HKEY); } catch (e) {}
  }
  var shopUrl = NewarkYMM.searchUrl;
  var esc = NewarkYMM.esc;

  function panelHtml(v) {
    var cur = v && v.make ? v : null;
    var prev = history().filter(function (x) { return !cur || label(x) !== label(cur); }).slice(0, HISTORY_SHOWN);
    var html = '';
    if (cur) {
      html += '<p class="ymm-gpanel__section">Your vehicle</p>' +
        '<p class="ymm-gpanel__vehicle">' + esc(label(cur)) + '</p>' +
        '<a class="ymm-gpanel__shop" href="' + shopUrl(cur) + '">Shop parts for this car&nbsp;&rarr;</a>' +
        '<div class="ymm-gpanel__row">' +
        '<button type="button" class="ymm-gpanel__btn" data-ymm-garage-change>Change vehicle</button>' +
        '<button type="button" class="ymm-gpanel__btn" data-ymm-garage-remove>Remove</button>' +
        '</div>';
    } else {
      html += '<p class="ymm-gpanel__section">Your vehicle</p>' +
        '<p class="ymm-gpanel__empty">No vehicle saved yet.</p>' +
        '<button type="button" class="ymm-gpanel__shop" data-ymm-garage-change>Choose your vehicle&nbsp;&rarr;</button>';
    }
    if (prev.length) {
      html += '<div class="ymm-gpanel__prev"><p class="ymm-gpanel__section">Previous vehicles</p>';
      prev.forEach(function (x, i) {
        html += '<div class="ymm-gpanel__prevrow">' +
          '<button type="button" class="ymm-gpanel__switch" data-ymm-garage-switch="' + i + '">' + esc(label(x)) + '</button>' +
          '<button type="button" class="ymm-gpanel__hx" data-ymm-garage-hremove="' + i + '" aria-label="Remove ' + esc(label(x)) + ' from previous vehicles" title="Remove from list">&times;</button>' +
          '</div>';
      });
      html += '<button type="button" class="ymm-gpanel__hclear" data-ymm-garage-hclear>Clear history</button></div>';
    }
    return html;
  }

  function render() {
    var v = read();
    document.querySelectorAll('[data-ymm-garage]').forEach(function (root) {
      var lbl = root.querySelector('[data-ymm-garage-label]');
      var content = root.querySelector('[data-ymm-garage-panel-content]');
      if (v && v.make) {
        root.classList.add('is-set');
        if (lbl) lbl.textContent = label(v);
      } else {
        root.classList.remove('is-set');
        if (lbl) lbl.textContent = 'No vehicle yet';
      }
      if (content) content.innerHTML = panelHtml(v);
    });
  }

  function closePanels() {
    document.querySelectorAll('[data-ymm-garage-panel]').forEach(function (p) { p.hidden = true; });
    document.querySelectorAll('[data-ymm-garage-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }

  // All garage mutations announce themselves on 'ymm:vehicle' so every surface
  // (header, vehicle banner, PDP fitment box) re-renders from ONE source of truth.
  function announce() {
    document.dispatchEvent(new CustomEvent('ymm:vehicle'));
  }
  // Mirror the garage vehicle onto the CART as an attribute ("Vehicle: 1972 MG MGB") so
  // every order records the shopper's exact YMM lookup in Admin (Additional details).
  // Idempotent + debounced; only POSTs when the stored value actually differs.
  var cartSyncT = null;
  function syncCartAttribute() {
    clearTimeout(cartSyncT);
    cartSyncT = setTimeout(function () {
      var v = read();
      var want = v && v.make ? label(v) : '';
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var have = (c && c.attributes && c.attributes.Vehicle) || '';
          if (have === want) return;
          if (!want && !have) return;
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { Vehicle: want } }),
          });
        })
        .catch(function () {});
    }, 300);
  }
  document.addEventListener('ymm:vehicle', syncCartAttribute);
  document.addEventListener('cart:refresh', syncCartAttribute);
  syncCartAttribute();
  function set(v) {
    if (!v || !v.make) return;
    var cur = read();
    if (cur && cur.make && label(cur) !== label(v)) pushHistory(cur);
    write({ make: v.make, model: v.model || '', year: v.year || '' });
    render();
    announce();
  }
  function clear() {
    var cur = read();
    if (cur && cur.make) pushHistory(cur);
    try { localStorage.removeItem(KEY); } catch (e) {}
    render();
    announce();
  }
  // Strip vehicle filter params so the page stops claiming a project we just changed.
  function stripFiltersAndReload() {
    var p = new URLSearchParams(location.search);
    if (!p.has('filter.p.m.filters.make')) return false;
    Array.from(p.keys()).forEach(function (k) {
      if (k.indexOf('filter.') === 0) p.delete(k);
    });
    var qs = p.toString();
    window.location.href = location.pathname + (qs ? '?' + qs : '');
    return true;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var toggle = t.closest && t.closest('[data-ymm-garage-toggle]');
    if (toggle) {
      var panel = toggle.parentElement.querySelector('[data-ymm-garage-panel]');
      var opening = panel && panel.hidden;
      closePanels();
      if (panel && opening) {
        // On phones the panel is position:fixed full-width; pin it under the pill.
        panel.style.top = window.innerWidth < 750 ? (toggle.getBoundingClientRect().bottom + 8) + 'px' : '';
        var c = panel.querySelector('[data-ymm-garage-panel-content]');
        var pk = panel.querySelector('[data-ymm-garage-picker]');
        if (c) c.hidden = false;
        if (pk) pk.hidden = true;
        panel.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
      }
      return;
    }
    if (t.closest && t.closest('[data-ymm-garage-remove]')) {
      clear();
      if (!stripFiltersAndReload()) render(); // panel stays open, now in empty state
      return;
    }
    if (t.closest && t.closest('[data-ymm-garage-change]')) {
      // Pick the new vehicle right here in the panel; the current one stays until
      // the new pick lands (set() moves it into Previous automatically).
      var host = t.closest('[data-ymm-garage-panel]');
      var content2 = host && host.querySelector('[data-ymm-garage-panel-content]');
      var picker = host && host.querySelector('[data-ymm-garage-picker]');
      if (picker) {
        if (content2) content2.hidden = true;
        picker.hidden = false;
        var w = picker.querySelector('[data-ymm-search]');
        if (w && !w.hasAttribute('data-ymm-inited') && window.NewarkYmmInit) {
          w.setAttribute('data-ymm-inited', '');
          window.NewarkYmmInit(w);
        }
      } else {
        clear();
        window.location.href = '/';
      }
      return;
    }
    var hx = t.closest && t.closest('[data-ymm-garage-hremove]');
    if (hx) {
      // Same filtered list the panel rendered from — map index back to a label.
      var cur0 = read();
      var shown = history().filter(function (x) { return !cur0 || !cur0.make || label(x) !== label(cur0); }).slice(0, HISTORY_SHOWN);
      var victim = shown[parseInt(hx.getAttribute('data-ymm-garage-hremove'), 10)];
      if (victim) removeHistory(label(victim));
      render(); // panel stays open, list re-renders without the removed row
      return;
    }
    if (t.closest && t.closest('[data-ymm-garage-hclear]')) {
      clearHistory();
      render();
      return;
    }
    var sw = t.closest && t.closest('[data-ymm-garage-switch]');
    if (sw) {
      var prev = history();
      var cur = read();
      var list = prev.filter(function (x) { return !cur || !cur.make || label(x) !== label(cur); });
      var pick = list[parseInt(sw.getAttribute('data-ymm-garage-switch'), 10)];
      if (pick) {
        set(pick);
        window.location.href = shopUrl(pick);
      }
      return;
    }
    if (!(t.closest && t.closest('[data-ymm-garage]'))) closePanels();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePanels();
  });

  // (Auto-filter redirect runs synchronously in header.liquid, before first paint.)

  // On ANY vehicle-filtered page (collection or search) with no results, replace the
  // theme's hostile "No products found / use fewer filters" with a plain-English
  // message, an escape link, and the phone number.
  function vehicleEmptyState() {
    var onCollection = location.pathname.indexOf('/collections/') === 0;
    var onSearch = location.pathname.indexOf('/search') === 0;
    if (!onCollection && !onSearch) return;
    var params = new URLSearchParams(location.search);
    var make = params.get('filter.p.m.filters.make');
    if (!make) return;
    if (document.querySelector('.ymm-row')) return;              // has results
    var grid = document.querySelector('#ProductGridContainer');
    if (!grid || document.querySelector('.ymm-vehicle-empty')) return;

    var mmyp = params.get('filter.p.m.filters.mmy');
    var mq = mmyp && mmyp.split('|').length === 3 ? mmyp.split('|') : null;
    // URL params are attacker-controlled — escape EVERYTHING interpolated into innerHTML.
    var vlabel = esc(mq ? mq[2] + ' ' + mq[0] + ' ' + mq[1]
      : [params.get('filter.p.m.filters.years'), make, params.get('filter.p.m.filters.model')]
      .filter(Boolean).join(' '));
    var ptype = params.get('filter.p.product_type');
    if (ptype && !/s$/i.test(ptype)) ptype += 's';
    var lead = ptype
      ? 'We don’t make ' + esc(ptype.toLowerCase()) + ' for your <strong>' + vlabel + '</strong> yet.'
      : 'We don’t have parts for your <strong>' + vlabel + '</strong> in this category yet.';

    var escape;
    if (onCollection) {
      escape = '<a class="ymm-vehicle-empty__all" href="' + esc(location.pathname) + '?garage=off">View all in this category →</a>';
    } else {
      // On search, the useful escape is everything we DO make for this vehicle.
      var ep = new URLSearchParams();
      ep.set('filter.p.m.filters.make', make);
      if (params.get('filter.p.m.filters.model')) ep.set('filter.p.m.filters.model', params.get('filter.p.m.filters.model'));
      if (params.get('filter.p.m.filters.years')) ep.set('filter.p.m.filters.years', params.get('filter.p.m.filters.years'));
      escape = '<a class="ymm-vehicle-empty__all" href="/collections/all?' + esc(ep.toString()) + '">See everything for your ' + vlabel + ' →</a>';
    }

    // Hide the theme's generic empty message so ours is the only one.
    grid.querySelectorAll('.title-wrapper, .loading-overlay').forEach(function (el) { el.style.display = 'none'; });

    var box = document.createElement('div');
    box.className = 'ymm-vehicle-empty';
    box.innerHTML = lead + '<br>' + escape +
      '<span class="ymm-vehicle-empty__phone">Or call <a href="tel:+18885417130">(888) 541-7130</a> — we’ll check for you.</span>';
    grid.insertAdjacentElement('afterbegin', box);
  }

  window.NewarkGarage = { get: read, set: set, clear: clear, render: render };
  document.addEventListener('ymm:vehicle', render);
  render();
  vehicleEmptyState();
  // Algolia re-renders the results list after load: re-check the empty state.
  document.addEventListener('ymm:results', vehicleEmptyState);
})();
